import axios from 'axios';
import { alert } from 'components/Alert';
// import dotenv from 'dotenv'
// dotenv.config()

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL
})

const token = window.sessionStorage.getItem('token')
if (token) {
  setToken(token)
}

export function setToken(token) {
  if (token) {
    instance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete instance.defaults.headers.common['Authorization'];
  }
}

instance.interceptors.request.use(
  (config) => {
    // Add any custom headers or configurations here
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use((config) => {
  return config
}, error => {
  if (error.status == 401) {
    const rotasAuth = ['/auth']
    const rotaAuth = rotasAuth.some(final => error.request.responseURL.endsWith(final))
    if (!rotaAuth) {
      console.log('Acesso negado', error.request.responseURL)
      window.sessionStorage.removeItem('user')
      window.location.href = '/'
    }
  }
  return Promise.reject(error)
})

class ApiService {
  async get(endpoint) {
    const res = await instance.get(endpoint);
    return res.data
  }

  async getBlob(endpoint, nomeArquivo) {
    const res = await instance.get(endpoint, {
      responseType: 'blob'
    });
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', nomeArquivo);
    document.body.appendChild(link);
    link.click();
    link.remove();
    return res.headers
  }

  async post(endpoint, data, config) {
    // SDD 034 - `config` opcional permite sobrescrever o header Authorization numa chamada
    // pontual (ex.: POST /auth/selecionar_papel com o preAuthToken, antes de existir um token
    // completo setado globalmente via setToken()).
    const res = await instance.post(endpoint, data, config);
    return res.data
  }

  async put(endpoint, data) {
    const res = await instance.put(endpoint, data);
    return res.data
  }

  async delete(endpoint, data) {
    const res = await instance.delete(endpoint, data ? { data } : undefined);
    return res.data
  }
}

const apiService = new ApiService()
export default apiService